(() => {
  if (window.ycPageMotion) return;
  window.ycPageMotion = true;
  function init() {
    const preference = matchMedia('(prefers-reduced-motion: reduce)');
    if (!('IntersectionObserver' in window)) return;
    const cards = '.product-card-wrapper, [class^="ai-bookshelf-card-"], .yc-book-card';
    const content = 'main, #MainContent, .page-directory-wrapper, .content-wrapper, .yc-directory-preview-content';
    const excluded = 'header, footer, nav, form, dialog, [role="dialog"], .yc-cart, .yc-info, .yc-fixed-next, .yc-slides-outer, .yc-controls, .yc-product-directory, .floating-music-player, .yc-masthead, .slideshow-image-container, .product-card-slideshow, [class*="ai-bookshelf-modal-"], [class*="ai-bookshelf-slideshow-"], [class*="ai-book-viewer__pages-"], #shopify-section-mobile-hero-slideshow';
    const known = new WeakSet();
    const observer = new IntersectionObserver(entries => {
      let stagger = 0;
      entries.forEach(({target,isIntersecting}) => {
        if (!isIntersecting) return;
        target.style.setProperty('--yc-page-delay', `${Math.min(stagger++ * 65,195)}ms`);
        target.classList.add('yc-page-shown');
        observer.unobserve(target);
      });
    }, {threshold:.05,rootMargin:'0px 0px -24px 0px'});
    function scan(root) {
      if (preference.matches || !root.querySelectorAll) return;
      const candidates = [...root.querySelectorAll(`${cards}, img, h1, h2, p, blockquote`)];
      if (root.matches?.(`${cards}, img, h1, h2, p, blockquote`)) candidates.unshift(root);
      candidates.forEach(el => {
        if (known.has(el) || el.closest(excluded)) return;
        const card = el.matches(cards);
        if (!card && (!el.closest(content) || el.closest(cards))) return;
        // Animate the photograph or text once, never both it and its parent.
        if (!card && el.parentElement?.closest('blockquote')) return;
        if (el.tagName === 'IMG' && (el.getAttribute('width') === '16' || /icon|logo|placeholder/i.test(el.getAttribute('src') || ''))) return;
        known.add(el);
        el.classList.add('yc-page-rise');
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (preference.matches) el.classList.add('yc-page-shown');
          else if (el.isConnected) observer.observe(el);
        }));
      });
    }
    scan(document);
    // Folder pages are inserted after navigation without a full page reload.
    new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1) scan(node);
    }))).observe(document.body,{childList:true,subtree:true});
    preference.addEventListener('change', () => {
      if (!preference.matches) return;
      observer.disconnect();
      document.querySelectorAll('.yc-page-rise').forEach(el => el.classList.add('yc-page-shown'));
    });
    document.addEventListener('focusin', event => event.target.closest?.('.yc-page-rise')?.classList.add('yc-page-shown'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
